export const useFormatNumbersWithScale = () => {
  const formatNumberToLocale = (value: number) => {
    if (isNaN(value)) return '-'

    return value.toLocaleString('es-AR')
  }

  return { formatNumberToLocale }
}
